import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroGuaritaListaNotas {
  lastSetDefault: Date;

  DF2EMISSAO_DE: Date | undefined;
  DF2EMISSAO_ATE: Date | undefined;
  CC5GUARITA: string;
  CC5NUM: string;
  CF2DOC: string;
}

export class FiltroGuaritaListaNotas {

  dados: IFiltroGuaritaListaNotas;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-notas-guarita';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroGuaritaListaNotas) => {
      if (filtro) {

        const {
          lastSetDefault,
          CC5GUARITA,
          CF2DOC,
          DF2EMISSAO_DE,
          DF2EMISSAO_ATE,
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            CC5GUARITA: CC5GUARITA,
            CF2DOC: CF2DOC,
            DF2EMISSAO_DE: DF2EMISSAO_DE ? new Date(DF2EMISSAO_DE) : undefined,
            DF2EMISSAO_ATE: DF2EMISSAO_ATE ? new Date(DF2EMISSAO_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroGuaritaListaNotas => {
    return {
      lastSetDefault: new Date(),
      DF2EMISSAO_DE: this.getData(-7),
      DF2EMISSAO_ATE: new Date(),
      CC5NUM: '',
      CC5GUARITA: '',
      CF2DOC: ''
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
